import { render, staticRenderFns } from "./notaMenu.vue?vue&type=template&id=21fae524"
import script from "./notaMenu.vue?vue&type=script&lang=js"
export * from "./notaMenu.vue?vue&type=script&lang=js"
import style0 from "./notaMenu.vue?vue&type=style&index=0&id=21fae524&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports